<template>
    <div :class="$style['health-message-edit']">
      <div class="tip-message">
        <p>更改地区后，以下信息将更新：</p>
        <p>销售订单的所属分公司</p>
        <p>报名记录的地区信息</p>
        <p>奖励发放记录的所属分公司</p>
        <p>奖励审核操作的所属分公司</p>
       </div>
         <pt-message-table-item label="选择地区">
        <pt-address-select v-model="address" required clearable @change="change"  data-vv-as="发票地址" name="name"
              v-validate="'required'" ref="address"  :showElement="showElement"></pt-address-select>
              </pt-message-table-item>
              <div  :class="$style['button-div']">
                  <el-button type="primary" @click="submit" :loading="loading">确定</el-button>
                  <el-button type="primary" plain @click="cancel">取消</el-button>
              </div>
    </div>
</template>
<script>
import ptAddressSelect from 'cps/base/pt-address-select/withData'
export default {
  components: {
    ptAddressSelect
  },
  props: {
    genericFormData: Object,
    mallOrderId: String,
    registrationId: String
  },
  data () {
    return {
      address: {},
      newAdress: [],
      showElement: {
        province: true,
        city: true,
        district: true
      },
      loading: false
    }
  },
  methods: {
    change (val) {
      this.address = val
      this.newAdress = [
        {
          value: val.provinceGbCode,
          text: val.provinceName
        },
        {
          value: val.cityGbCode,
          text: val.cityName
        },
        {
          value: val.districtGbCode,
          text: val.districtName
        }
      ]
    },
    cancel () {
      this.$emit('closeDialog')
    },
    submit () {
      let data = {
        genericFormData: {
          data: {
            address: this.newAdress
          }
        },
        mallOrderId: this.mallOrderId,
        registrationId: this.registrationId
      }
      this.loading = true
      this.$store.dispatch('editOrderInfo', data).then(res => {
        this.loading = false
        this.$message.success('编辑地址信息成功')
        this.$emit('closeDialog', true)
      }).catch(err => {
        this.loading = false
        this.$message(err || '编辑地址信息失败')
      })
    }
  },
  created () {
    if (this.genericFormData.address && this.genericFormData.address.length) {
      this.address.provinceGbCode = this.genericFormData.address[0] && this.genericFormData.address[0].value
      this.address.cityGbCode = this.genericFormData.address[1] && this.genericFormData.address[1].value
      this.address.districtGbCode = this.genericFormData.address[2] && this.genericFormData.address[2].value
    }
  }
}
</script>
<style module lang="less">
.health-message-edit{
  p{
    color:red;
    line-height: 25px;
    font-size: 13px;
    margin-block-start:0;
    margin-block-end:0
  }
    .button-div{
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }
    :global{
      .tip-message{
        margin-bottom: 15px;
      }
    }
}
</style>
